import router from '@/router'
import axios from '@/plugins/axios'

const moduleConfig = {
	namespaced: true,
	state: {
    ACTIVITY_SUMMARY: "",   // 活动概要
    HEAD_BANNER_PC: "",   // 头部banner pc图片素材地址
    HEAD_BANNER_MOBILE: "",   //头部banner mobile图片素材地址
    NAV_BANNER_OPEN_PC: "",   // 导航banner 开放状态 pc图片素材地址
    NAV_BANNER_OPEN_MOBILE: "",   // 导航banner 开放状态 mobile图片素材地址
    NAV_BANNER_OPEN_LINK: "",   // 导航banner 开放状态 链接地址
    NAV_BANNER_CLOSE_PC: "",    // 导航banner 开放状态 pc图片素材地址
    NAV_BANNER_CLOSE_MOBILE: "",    // 导航banner 关闭状态 mobile图片素材地址
    NAV_BANNER_CLOSE_LINK: "",    //导航banner 关闭状态 链接地址
    UPLOAD_OPEN: "",   // 上传功能开放状态
    MAX_DIFFICULTY: ""    // 下拉框最大危机等级
  },
	mutations: {
    SET_BASE_CONFIG: (state, params) => {
      params["activitySummary"] && (state.ACTIVITY_SUMMARY = params["activitySummary"]);
      params["headBannerPc"] && (state.HEAD_BANNER_PC = params["headBannerPc"]);
      params["headBannerMobile"] && (state.HEAD_BANNER_MOBILE = params["headBannerMobile"]);
      params["navBannerOpenPc"] && (state.NAV_BANNER_OPEN_PC = params["navBannerOpenPc"]);
      params["navBannerOpenMobile"] && (state.NAV_BANNER_OPEN_MOBILE = params["navBannerOpenMobile"]);
      params["navBannerOpenLink"] && (state.NAV_BANNER_OPEN_LINK = params["navBannerOpenLink"]);
      params["navBannerClosePc"] && (state.NAV_BANNER_CLOSE_PC = params["navBannerClosePc"]);
      params["navBannerCloseMobile"] && (state.NAV_BANNER_CLOSE_MOBILE = params["navBannerCloseMobile"]);
      params["navBannerCloseLink"] && (state.NAV_BANNER_CLOSE_LINK = params["navBannerCloseLink"]);
      params["maxDifficulty"] && (state.MAX_DIFFICULTY = params["maxDifficulty"]);
      state.UPLOAD_OPEN = params["uploadOpen"];
    }
  },
	actions: {
		getBaseInfo({ commit }) {
			return new Promise((resolve, reject) => {
				axios
					.get('/base-config')
					.then(v => {
            console.log("[base-config]", v)
						if (v.retcode == 2000 && v.data) {
              commit("SET_BASE_CONFIG", v.data)
						} 
						resolve(v)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
	},
	getters: {},
}

export default moduleConfig
